import merge from 'classnames';

import { SimpleIconProps } from '../types';

export const IconLogout = ({ className }: SimpleIconProps) => (
  <svg
    className={merge(className)}
    height="20"
    role="img"
    viewBox="0 0 22 20"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.667 1.111C1.753 1.111 1 1.864 1 2.778v14.444c0 .914.753 1.667 1.667 1.667h10c.913 0 1.666-.753 1.666-1.667v-3.889h-1.11v3.89a.543.543 0 0 1-.556.555h-10a.543.543 0 0 1-.556-.556V2.778c0-.318.238-.556.556-.556h10c.317 0 .555.238.555.556v5h1.111v-5c0-.914-.753-1.667-1.666-1.667h-10zm14.496 5.77l-.785.786 2.385 2.385h-8.66v1.111h8.66l-2.385 2.385.785.786 3.726-3.726-3.726-3.726z"
      fill="#FFF"
      fillRule="evenodd"
      stroke="#FFF"
      strokeWidth=".5"
    />
  </svg>
);
